export const calculateFee = (amount: number): number => {
  let fee = 0;
  if (amount >= 1 && amount <= 6666) {
    fee = 100;
  } else if (amount > 6666 && amount <= 33333) {
    let roundFee = amount * (1.5 / 100);
    fee = Math.round(roundFee * 10) / 10;
  } else if (amount > 33333) {
    return 500;
  }
  return fee;
};
